module.exports = __webpack_public_path__ + "static/media/pres-sec2.6cd2292c.webp";